import { root } from './names';

export const names = {
  ...root,
};
